import { create } from "zustand"
import { persist } from "zustand/middleware"

interface CartTourState {
  hasSeenCartTour: boolean
  isCartTourVisible: boolean
  showCartTour: () => void
  hideCartTour: () => void
  markCartTourAsSeen: () => void
}

export const useCartTourStore = create<CartTourState>()(
  persist(
    (set) => ({
      hasSeenCartTour: false,
      isCartTourVisible: false,
      showCartTour: () => set({ isCartTourVisible: true }),
      hideCartTour: () => set({ isCartTourVisible: false }),
      markCartTourAsSeen: () =>
        set({ hasSeenCartTour: true, isCartTourVisible: false }),
    }),
    {
      name: "cart-tour-storage",
    }
  )
)
